import type { OtherUser } from '@talos/kyoko';
import { createContext, useContext } from 'react';

export type UsersContextState = {
  isLoaded: boolean;
  users: OtherUser[];
  userByUserName: Map<string, OtherUser>;
  userByID: Map<string, OtherUser>;
  refetchUsers: (includeDeleted?: boolean) => Promise<void>;
};
export const UsersContext = createContext<UsersContextState | undefined>(undefined);
UsersContext.displayName = 'UsersContext';
export const useUsersContext = (): UsersContextState => {
  const context = useContext(UsersContext);
  if (context == null) {
    throw new Error('Missing UsersContext.Provider further up in the tree. Did you forget to add it?');
  }
  return context;
};
